/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useRef, useState } from "react"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import TextInput from "../../../components/InputWrapper/TextInput"
import { e工程区分 } from "../../../constant/enum/zyutuHaisya"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { 区分分類コード } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import { TKaikonZyutyuHaisyaKoteiPatternGetRes } from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"
import { useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import { T積卸先 } from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import { get積卸ItemsSourceByApi } from "../../../ts/util/autoCompleteUtil"

// const 工程Colors = { 1: "#E3F2FD", 2: "#BBDEFB", 3: "#90CAF9", 4: "#64B5F6" }

const SagyoGridRow: React.FC<{
  initState: TKaikonZyutyuHaisyaKoteiPatternGetRes | undefined
  setState: (v: TKaikonZyutyuHaisyaKoteiPatternGetRes) => unknown
  ninusiCode: string | undefined
  busyoItemSource: T部所マスタ[]
  kubunItemSource: T区分マスタ[]
}> = (props) => {
  //#region [state]
  const userInfo = useSelector((state: RootState) => state.user.LoginUserInfo)
  const [受注配車パターンID, set受注配車パターンID] = useState<number>()
  const [受注配車工程パターンID, set受注配車工程パターンID] = useState<number>()
  const [積卸先ID, set積卸先ID] = useState<number>()
  const [積卸先コード, set積卸先コード] = useState<string>()
  const [積卸先名, set積卸先名] = useState<string>()
  const [積卸先都道府県, set積卸先都道府県] = useState<string>()
  const [積卸先市区町村, set積卸先市区町村] = useState<string>()
  const [海コン作業内容, set海コン作業内容] = useState<string>()
  const [運行部所コード, set運行部所コード] = useState<string>()
  const [乗務員売上額, set乗務員売上額] = useState<number>()
  const [海コン付帯高速料, set海コン付帯高速料] = useState<number>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [海コン付帯作業手当, set海コン付帯作業手当] = useState<number>()
  const [工程備考, set工程備考] = useState<string>()
  const [支払先ID, set支払先ID] = useState<number>()
  const [更新日時, set更新日時] = useState<string>()

  const [海コン付帯作業区分コード, set海コン付帯作業区分コード] =
    useState<string>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // autocompleteの検索がstateの変更に耐えきれるようにrefに格納
  const 荷主コードRef = useRef<string>()
  const pre積卸先コードRef = useRef<string | null>()

  // combobox
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  // 海コン付帯作業区分
  const [海コン付帯作業区分ComboBox, set海コン付帯作業区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [海コン付帯作業区分IsLoadEnded, set海コン付帯作業区分IsLoadEnded] =
    useState<boolean>(false)

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)
  // 画面初期化フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  const [pageInitialized, setPageInitialized] = useState(false)
  //#endregion

  //#region [method]

  const getTumiOrosiSakiItemsSource: wjcInput.IGetItems = async (
    query,
    max,
    callback
  ) => {
    const 荷主コード = 荷主コードRef.current ?? ""

    if (荷主コード === "") {
      callback([])
      return
    }
    get積卸ItemsSourceByApi(query, max, callback, 荷主コード)
  }

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (comboDataInitialized && 部所ComboBox && 海コン付帯作業区分ComboBox) {
      setPageInitialized(true)
    }
  }, [comboDataInitialized, 部所ComboBox, 海コン付帯作業区分ComboBox])
  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (pageInitialized) {
      // 初期値をログインユーザの部所コードとする
      set運行部所コード(userInfo.部所コード)
    }
  }, [pageInitialized])
  useEffect(() => {
    const data = props.initState
    set受注配車パターンID(data?.受注配車パターンID)
    set受注配車工程パターンID(data?.受注配車工程パターンID)
    set積卸先ID(data?.積卸先ID)
    set積卸先コード(data?.積卸先コード)
    set積卸先名(data?.積卸先名)
    set積卸先都道府県(data?.積卸先都道府県)
    set積卸先市区町村(data?.積卸先市区町村)
    set海コン作業内容(data?.海コン作業内容)
    set運行部所コード(data?.運行部所コード ?? userInfo.部所コード)
    set支払先ID(data?.支払先ID)
    set乗務員売上額(data?.乗務員売上額)
    set海コン付帯作業区分コード(data?.海コン付帯作業区分コード)
    set海コン付帯作業手当(data?.海コン付帯作業手当)
    set海コン付帯高速料(data?.海コン付帯高速料)
    set工程備考(data?.工程備考)
    set更新日時(data?.更新日時)
  }, [props.initState])

  useEffect(() => {
    props.setState({
      ...props.initState,
      受注配車パターンID,
      受注配車工程パターンID,
      積卸先ID,
      積卸先コード,
      積卸先名,
      積卸先都道府県,
      積卸先市区町村,
      海コン作業内容,
      海コン付帯作業手当,
      運行部所コード,
      乗務員売上額,
      海コン付帯高速料,
      海コン付帯作業区分コード,
      工程備考,
      支払先ID,
      更新日時,
    })
  }, [
    積卸先ID,
    積卸先コード,
    積卸先名,
    積卸先都道府県,
    積卸先市区町村,
    海コン作業内容,
    海コン付帯作業手当,
    運行部所コード,
    乗務員売上額,
    海コン付帯高速料,
    海コン付帯作業区分コード,
    工程備考,
    支払先ID,
    更新日時,
  ])

  useEffect(() => {
    if (積卸先コード === "") {
      set積卸先名("")
      set積卸先都道府県("")
      set積卸先市区町村("")
    }
  }, [積卸先コード])

  useEffect(() => {
    set部所ItemSource(props.busyoItemSource)
    set区分ItemSource(props.kubunItemSource)
  }, [props.busyoItemSource, props.kubunItemSource])
  //TODO:部所情報の取得はどちらに持たせるか要検討
  useEffect(() => {
    if (部所IsLoadEnded && 海コン付帯作業区分IsLoadEnded) {
      setComboDataInitialized(true)
    }
  }, [部所IsLoadEnded, 海コン付帯作業区分IsLoadEnded])

  useEffect(() => {
    荷主コードRef.current = props.ninusiCode
  }, [props.ninusiCode])
  //#endregion

  return (
    <>
      <tr>
        {/* 作業工程 */}
        <th className={`kotei-cell-color-${props.initState?.工程区分コード}`}>
          {" "}
          {props.initState?.工程区分名称1}
        </th>
        {/* 積卸先コード */}
        <td>
          <div className="d-flex">
            <wjrInput.AutoComplete
              className="w-10rem"
              headerPath={"積卸先コード"}
              text={積卸先コード}
              showDropDownButton={false}
              minLength={1}
              gotFocus={(control: wjcInput.AutoComplete) => {
                // 変更前後を確認
                pre積卸先コードRef.current = control.text
                control.itemsSourceFunction = getTumiOrosiSakiItemsSource
              }}
              lostFocus={(control: wjcInput.AutoComplete) => {
                if (control.selectedItem) {
                  const 積卸先: T積卸先 = control.selectedItem
                  set積卸先ID(積卸先.積卸先ID)
                  set積卸先コード(積卸先.積卸先コード)
                  set積卸先名(積卸先.積卸先略称)
                  set積卸先都道府県(積卸先.住所１)
                  set積卸先市区町村(積卸先.住所２)
                } else {
                  // 修正前と変わってなければ特に処理せず抜ける
                  if (pre積卸先コードRef.current === control.text) return

                  // 1つしかアイテムがない場合、先頭を取得し埋め込む
                  const itemsSource: T積卸先[] = control.itemsSource ?? []
                  if (itemsSource.length === 1) {
                    const 積卸先: T積卸先 = control.selectedItem
                    set積卸先ID(積卸先.積卸先ID)
                    set積卸先コード(積卸先.積卸先コード)
                    set積卸先名(積卸先.積卸先略称)
                    set積卸先都道府県(積卸先.住所１)
                    set積卸先市区町村(積卸先.住所２)
                  } else {
                    set積卸先ID(undefined)
                    set積卸先コード("")
                    set積卸先名("")
                    set積卸先都道府県("")
                    set積卸先市区町村("")
                  }
                }
              }}
              displayMemberPath={"displayName"}
              selectedValuePath={"積卸先コード"}></wjrInput.AutoComplete>
            <button
              type="button"
              className="icon-button"
              onClick={(e) => {
                e.preventDefault()
                setIs積卸先検索Modal(true)
              }}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faSearch}></FontAwesomeIcon>
            </button>
          </div>
        </td>
        {/* 社名（ヤード） */}
        <td>
          <div className="d-flex">
            <TextInput
              className="w-10rem"
              name="社名"
              value={積卸先名}
              setValue={set積卸先名}></TextInput>
          </div>
        </td>
        {/* 都道府県 */}
        <td>
          <TextInput
            className="w-12rem"
            name="積卸先都道府県"
            placeholder=""
            value={積卸先都道府県}
            setValue={(v) => {
              set積卸先都道府県(v)
            }}></TextInput>
        </td>
        {/* 市区町村 */}
        <td>
          <TextInput
            className="w-12rem"
            name="積卸先市区町村"
            placeholder=""
            value={積卸先市区町村}
            setValue={(v) => {
              set積卸先市区町村(v)
            }}></TextInput>
        </td>
        {/* 作業内容 */}
        <td>
          {/* PICKと返却には存在しない */}
          {(props.initState?.工程区分コード === e工程区分.作業 ||
            props.initState?.工程区分コード === e工程区分.その他) && (
            <TextInput
              className="w-12rem"
              name="海コン作業内容"
              placeholder=""
              value={海コン作業内容}
              setValue={(v) => {
                set海コン作業内容(v)
              }}></TextInput>
          )}
        </td>
        {/* 運行部所 */}
        <td>
          <ComboBox.Busyo
            className="w-12rem"
            isEmpty={true}
            itemsSource={部所ItemSource}
            isLoadEnded={部所IsLoadEnded}
            setIsLoadEnded={set部所IsLoadEnded}
            listFilter={(d) => d.運行部所フラグ === 1}
            setSelectedValue={(v) => {
              v != null ? set運行部所コード(v) : set運行部所コード(undefined)
            }}
            selectedValue={運行部所コード}
            ComboBox={部所ComboBox}
            setComboBox={set部所ComboBox}></ComboBox.Busyo>
        </td>
        {/* 乗務員売上額 */}
        <td>
          <wjrInput.InputNumber
            className="w-12rem"
            value={乗務員売上額}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set乗務員売上額(c.value)
                : set乗務員売上額(undefined)
            }}
            format={"n0"}
            isRequired={false}></wjrInput.InputNumber>
        </td>
        {/* 付帯高速料 */}
        <td>
          <wjrInput.InputNumber
            className="w-12rem"
            value={海コン付帯高速料}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set海コン付帯高速料(c.value)
                : set海コン付帯高速料(undefined)
            }}
            format={"n0"}
            isRequired={false}></wjrInput.InputNumber>
        </td>
        {/* 海コン付帯作業手当 */}
        <td>
          <ComboBox.Kubun
            className="w-12rem"
            分類コード={区分分類コード.受注配車_請求支払.海コン付帯作業区分}
            isLoadEnded={海コン付帯作業区分IsLoadEnded}
            setIsLoadEnded={set海コン付帯作業区分IsLoadEnded}
            isAllSelect={false}
            isEmpty={true}
            itemsSource={区分ItemSource}
            selectedValue={海コン付帯作業区分コード}
            setSelectedValue={(v) => {
              v != null
                ? set海コン付帯作業区分コード(v)
                : set海コン付帯作業区分コード(undefined)
            }}
            ComboBox={海コン付帯作業区分ComboBox}
            setComboBox={set海コン付帯作業区分ComboBox}></ComboBox.Kubun>
        </td>
        {/* 海コン付帯作業手当 */}
        <td>
          <wjrInput.InputNumber
            className={"w-4rem"}
            isRequired={false}
            handleWheel={false}
            value={海コン付帯作業手当}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set海コン付帯作業手当(c.value)
                : set海コン付帯作業手当(undefined)
            }}
            format={"n0"}></wjrInput.InputNumber>
        </td>
        {/* 工程備考 */}
        <td>
          <div className="d-flex">
            <TextInput
              className="w-10rem"
              name="工程備考"
              value={工程備考}
              setValue={set工程備考}></TextInput>
          </div>
        </td>
        {/* 作業工程 */}
        <th className={`kotei-cell-color-${props.initState?.工程区分コード}`}>
          {props.initState?.工程区分名称1}
        </th>
      </tr>
      {/* 積卸先検索 */}
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        isShow={is積卸先検索Modal}
        ninusiCode={props.ninusiCode}
        setTumiOrosiSaki={(積卸先) => {
          set積卸先ID(積卸先.積卸先ID)
          set積卸先コード(積卸先.積卸先コード)
          set積卸先名(積卸先.積卸先略称)
          set積卸先都道府県(積卸先.住所１ ?? "")
          set積卸先市区町村(積卸先.住所２ ?? "")
        }}></TumiOrosiSakiSearchModal>
    </>
  )
}

export default SagyoGridRow
